import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { Router, Link } from "@reach/router";
import Divider from "@material-ui/core/Divider";
import { withSnackbar } from "notistack";
// import store from "../../../../reduxstore";
import SERVER_ADDRESS from "../../../config";
import PanoCard from "./PanoCard";
import PanoIntro from "./PanoIntro";
import { useTestState } from "../../../ilabx-grade-return";

const useStyles = makeStyles(theme => ({
  grid: {
    flexGrow: 1
  },
  cardgrid: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  divider: {
    width: "100%"
  }
}));

//获取实景学习信息
function usePanos(initValue, enqueueSnackbar) {
  const [panoramas, setPanoramas] = useState(initValue);
  useEffect(() => {
    fetch(`${SERVER_ADDRESS}/api/panoramas.json/`, {
      headers: {
        Accept: "application/json, text/plain, */*"
      },
      mode: "cors",
      credentials: "include"
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res.json();
      })
      .then(data => {
        //反转数据顺序，后添加的资源在靠前位置显示
        data.reverse();
        setPanoramas(data);
        //成功后的反馈SnackBar
        // enqueueSnackbar("网络畅通", {
        //   variant: "success"
        // });
      })
      .catch(error => {
        //失败后显示错误SnackBar
        // console.log(error);
        enqueueSnackbar("无法连接服务器，请检查网络", {
          variant: "error"
        });
      });

    return () => {
      setPanoramas(initValue);
    };
  }, []);
  return panoramas;
}

//Main Component
function PanoPage(props) {
  const classes = useStyles();
  const panoramas = usePanos([], props.enqueueSnackbar);

  //ilabx update test state
  useTestState();

  return (
    <Grid container className={classes.grid} spacing={2} justify="center">
      <Grid container item xs={12} justify="center">
        <Grid item xs={12}>
          <PanoIntro />
        </Grid>
      </Grid>
      <Divider variant="fullWidth" className={classes.divider} light />

      <Grid container item xs={12} justify="center">
        {panoramas.map((pano, index) => (
          <Grid item xs={12} className={classes.cardgrid} key={pano.id}>
            <PanoCard pano={pano} index={index} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
export default withSnackbar(PanoPage);
